import { useAccountList } from '@ltvco/refresh-lib/hooks';
import { AccountListsListItem } from '@ltvco/refresh-lib/v1';
import { ListDetailsPage, LizanoListInfo } from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn } from '@ltvco/refresh-lib/vendors';
import { useParams } from 'react-router-dom';

export function ListsItem() {
  const { data, isLoading } = useAccountList();
  const { listName } = useParams<{ listName: string }>();
  const isInListV2Variation = useFeatureIsOn('prop-2834');

  if (isLoading) {
    return null;
  }

  const list: LizanoListInfo | undefined = data?.find(
    ({ name }: { name: string }) => name === listName
  ) as LizanoListInfo;

  if (isInListV2Variation) {
    return <ListDetailsPage list={list} />;
  }
  return <AccountListsListItem list={list || []} />;
}
